import { useParams } from 'react-router-dom';

import { AppAdvancedSettingsPage } from '~/components/pages/AppAdvancedSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppAdvancedSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppAdvancedSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
